import { useFeatureAvailable } from 'App/components/hooks';
import { Feature } from 'Store/actions/FeatureHelperActions';

export default function useListOrdersAllowed() {
	return useFeatureAvailable(Feature.ORDERS);
}
